<template>
  <div>
    <template v-if="sendLinkShow">
      <div class="text-heading-3 text-primary-1 mb-5">
        {{ t('auth.forgotYourPassword') }}
      </div>
      <div class="text-gray-1 text-paragraph-1 mb-5">
        {{ t('auth.weSendYouALink') }}
      </div>
      <label class="text-heading-6 text-primary-1 block"> {{ t('auth.emailAddress') }} </label>
      <input
        ref="textInput"
        class="input-color rounded-[5px] w-full outline-none px-5 py-2 h-10 mt-3"
        :class="{ 'border border-red': hasError }"
        :placeholder="t('auth.email')"
        type="email"
        name="user-email"
        v-model="emailText"
      />
      <span class="text-red mt-2.5 flex gap-1 items-center">
        {{ errorMessage }}
      </span>
      <BaseButton
        type="primary"
        :label="t('auth.sendLink')"
        :height="56"
        class="!w-full mt-8"
        @click="sentLink"
      />
    </template>
    <template v-else>
      <div class="text-heading-3 text-primary-1 mb-5">
        {{ t('auth.howToResetPassword') }}:
      </div>
      <div class="text-gray-1 text-paragraph-1 mb-5">
        {{ t('auth.howToResetPasswordDescription') }}
      </div>
      <div class="text-gray-1 text-paragraph-1 mb-8">
        <div class="mb-5">1. {{ t('auth.howToResetPasswordStepOne') }} : {{ emailText }}</div>
        <div>2.{{ t('auth.howToResetPasswordStepTwo') }}.</div>
      </div>
      <BaseButton
        type="primary"
        :label="t('auth.done')"
        :height="56"
        class="!w-full"
        @click="doneForgot"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { validateEmailFormat } from "./../../../composables/helper";
const { sendLink } = useAuth();
import { ref } from "vue";
const config = useRuntimeConfig();
const { t } = useI18n();
const sendLinkShow = ref<boolean>(true);
const hasError = ref(false);
const errorMessage = ref<string>("");
const emit = defineEmits(["done-forgot"]);
const props = defineProps({
  email: {
    type: String,
    default: "",
  },
});
const emailText = ref<string>(props.email);

// function setTouched(event: Event) {
//   validateEmail(event);
// }
function validateEmail(event: Event | null = null) {
  const inputValue = event
    ? (event.target as HTMLInputElement).value.trim()
    : emailText.value
      ? emailText.value.trim()
      : "";
  if (inputValue && !validateEmailFormat(inputValue)) {
    errorMessage.value = t("auth.formatIsNotCorrect");
    return false;
  } else {
    errorMessage.value = "";
    return true;
  }
}
async function sentLink() {
  if (validateEmail()) {
    const res = await sendLink({
      email: emailText.value,
    });
    sendLinkShow.value = false;
  }
}
function doneForgot() {
  emit("done-forgot");
}
</script>
